(function () {
  function syncHasValue(input) {
    input.classList.toggle('has-value', input.value.length > 0);
  }

  function initAnimatedPlaceholder(bar) {
    var placeholderWrap = bar.querySelector('[data-animated-placeholder]');
    if (!placeholderWrap) return;

    var typedEl = placeholderWrap.querySelector('.typed-text');
    var input = bar.querySelector('input[type="search"]');
    var resetButton = bar.querySelector('.reset__button');
    if (!typedEl || !input) return;

    var phrases = [
      'What are you looking for?',
      'BMW',
      'Mercedes',
      'Porsche',
      'Exhausts',
      'Brake Fluid',
      'Apparels',
      'Accessories'
    ];

    var phraseIndex = 0;
    var charIndex = 0;
    var typing = true;

    var typeSpeed = 70;
    var deleteSpeed = 40;
    var pauseAfterType = 1400;
    var pauseAfterDelete = 400;

    function tick() {
      var current = phrases[phraseIndex];

      if (typing) {
        charIndex++;
        typedEl.textContent = current.slice(0, charIndex);

        if (charIndex === current.length) {
          typing = false;
          setTimeout(tick, pauseAfterType);
          return;
        }
        setTimeout(tick, typeSpeed);
      } else {
        charIndex--;
        typedEl.textContent = current.slice(0, charIndex);

        if (charIndex === 0) {
          typing = true;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          setTimeout(tick, pauseAfterDelete);
          return;
        }
        setTimeout(tick, deleteSpeed);
      }
    }

    setTimeout(tick, typeSpeed);

    // Covers the case where the input already has a value when the page
    // loads (e.g. landing on /search?q=... with the term pre-filled) -
    // without this, the animated overlay would sit on top of the real term.
    syncHasValue(input);

    input.addEventListener('input', function () {
      syncHasValue(input);
    });

    // The reset/clear button empties the field via its own click handler
    // (predictive-search.js / search-form.js), which doesn't reliably fire
    // a native 'input' event. Re-check right after that handler runs so the
    // animation reappears once the field is actually empty again.
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        setTimeout(function () {
          syncHasValue(input);
        }, 0);
      });
    }

    if (input.form) {
      input.form.addEventListener('reset', function () {
        setTimeout(function () {
          syncHasValue(input);
        }, 0);
      });
    }
  }

  function init() {
    document.querySelectorAll('.header-search-inline').forEach(initAnimatedPlaceholder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();